'use client';

import type { Session } from 'next-auth';
import { type FC, type PropsWithChildren, Suspense } from 'react';
import { SessionProvider } from 'next-auth/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@eqi-investimentos/react';
import { queryClient } from '@/config/queryClient';
import { ModalUnauthenticated } from '@/components/modules/ModalUnauthenticated';
import { MaintenanceModalAlert } from '@/modules/Maintenance/ui/MaintenanceModalAlert';
import { AuthSessionGate } from '@/contexts/AuthSessionSync';
import { ConfigProvider } from '@/contexts/ConfigContext';
import { InvestProvider } from '@/contexts/InvestContext';
import { Aeonik } from '@/themes/fonts';

const ClientRootProvider: FC<
  PropsWithChildren & { session: Session | null }
> = ({ children, session }) => {
  return (
    <ThemeProvider fontFamily={Aeonik.style.fontFamily}>
      <SessionProvider
        refetchOnWindowFocus={false}
        session={session}
        refetchInterval={60 * 5}
      >
        <AuthSessionGate initialSession={session}>
          <QueryClientProvider client={queryClient}>
            <ConfigProvider>
              <Suspense>
                <InvestProvider>
                  {children}
                  <ReactQueryDevtools
                    initialIsOpen={false}
                    buttonPosition="bottom-left"
                  />
                  <ModalUnauthenticated />
                  <MaintenanceModalAlert />
                </InvestProvider>
              </Suspense>
            </ConfigProvider>
          </QueryClientProvider>
        </AuthSessionGate>
      </SessionProvider>
    </ThemeProvider>
  );
};

export default ClientRootProvider;
